var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { ParseError, Parser } from '../expression-evaluator';
import { CommandSocketInitializer } from './framework/CommandSocketInitializer';
import { pollableControlNames, } from './framework/Driver';
import { isRequestMethod } from './framework/HttpRequestInterface';
import { Timeouts } from './framework/Timeouts';
import { TransportError } from './framework/Transport';
export class UserDriverError extends Error {
    constructor(message) {
        super(message);
        this.component = 'UserDriver';
    }
}
const defaultVolumeRanges = {
    receiveGain: { max: 10, min: -10, round: 1 },
    trim: { max: 12, min: -12, round: 1 },
    volume: { max: 0, min: -50, round: 1 },
};
function createRegExp(name, def) {
    let regExp;
    try {
        regExp = new RegExp(def.value, def.ignoreCase ? 'i' : undefined);
    }
    catch (error) {
        throw new UserDriverError(`error parsing ${name} regular expression: ${def.value}`);
    }
    return regExp;
}
function getValuesSortedByKey(obj) {
    return Object.entries(obj)
        .sort((a, b) => a[0].localeCompare(b[0]))
        .map(e => e[1]);
}
function isUserDriverConfig(config) {
    return typeof config === 'string';
}
export class UserDriverSocket {
    constructor(socket, state, log, framework) {
        this.socket = socket;
        this.state = state;
        this.log = log;
        this.framework = framework;
        this.asts = {};
        this.timeouts = new Timeouts();
        this.busyTimeout = this.timeouts.create();
        // controls
        this.busy = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                return this.state.busy.value;
            }),
        };
        this.detected = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c, _d, _e;
                const channels = (_e = (_d = (_c = (_b = (_a = this.config) === null || _a === void 0 ? void 0 : _a.userDriver) === null || _b === void 0 ? void 0 : _b.controls) === null || _c === void 0 ? void 0 : _c.audio) === null || _d === void 0 ? void 0 : _d.channels) !== null && _e !== void 0 ? _e : [];
                return channels;
            }),
            hasControl: (config) => __awaiter(this, void 0, void 0, function* () { var _f, _g; return ((_g = (_f = config === null || config === void 0 ? void 0 : config.userDriver) === null || _f === void 0 ? void 0 : _f.controls) === null || _g === void 0 ? void 0 : _g.audio) !== undefined; }),
        };
        this.displayBlank = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                var _h, _j, _k;
                const value = yield this.getBoolean('displayBlank', (_k = (_j = (_h = this.config) === null || _h === void 0 ? void 0 : _h.userDriver) === null || _j === void 0 ? void 0 : _j.controls) === null || _k === void 0 ? void 0 : _k.displayBlank, tags);
                return value !== null && value !== void 0 ? value : false;
            }),
            set: (value, tags) => __awaiter(this, void 0, void 0, function* () {
                var _l, _m, _o, _p;
                const config = (_o = (_m = (_l = this.config) === null || _l === void 0 ? void 0 : _l.userDriver) === null || _m === void 0 ? void 0 : _m.controls) === null || _o === void 0 ? void 0 : _o.displayBlank;
                if (((_p = config === null || config === void 0 ? void 0 : config.set) === null || _p === void 0 ? void 0 : _p.onlySetIfChanged) && value === this.state.displayBlank.value) {
                    return value;
                }
                const newValue = yield this.setBoolean('displayBlank', config, value, tags);
                return newValue !== null && newValue !== void 0 ? newValue : this.state.displayBlank.value;
            }),
            isStateless: (config) => { var _a, _b, _c; return ((_c = (_b = (_a = config === null || config === void 0 ? void 0 : config.userDriver) === null || _a === void 0 ? void 0 : _a.controls) === null || _b === void 0 ? void 0 : _b.displayBlank) === null || _c === void 0 ? void 0 : _c.get) === undefined; },
            isToggle: (config) => { var _a, _b, _c; return ((_c = (_b = (_a = config === null || config === void 0 ? void 0 : config.userDriver) === null || _a === void 0 ? void 0 : _a.controls) === null || _b === void 0 ? void 0 : _b.displayBlank) === null || _c === void 0 ? void 0 : _c.isToggle) === true; },
            hasControl: (config) => __awaiter(this, void 0, void 0, function* () { var _q, _r; return ((_r = (_q = config === null || config === void 0 ? void 0 : config.userDriver) === null || _q === void 0 ? void 0 : _q.controls) === null || _r === void 0 ? void 0 : _r.displayBlank) !== undefined; }),
            powerOffRestrictions: (config) => { var _a, _b; return this.computePowerOffRestrictions((_b = (_a = config.userDriver) === null || _a === void 0 ? void 0 : _a.controls) === null || _b === void 0 ? void 0 : _b.displayBlank); },
        };
        this.displayFreeze = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                var _s, _t, _u;
                const value = yield this.getBoolean('displayFreeze', (_u = (_t = (_s = this.config) === null || _s === void 0 ? void 0 : _s.userDriver) === null || _t === void 0 ? void 0 : _t.controls) === null || _u === void 0 ? void 0 : _u.displayFreeze, tags);
                return value !== null && value !== void 0 ? value : false;
            }),
            set: (value, tags) => __awaiter(this, void 0, void 0, function* () {
                var _v, _w, _x, _y;
                const config = (_x = (_w = (_v = this.config) === null || _v === void 0 ? void 0 : _v.userDriver) === null || _w === void 0 ? void 0 : _w.controls) === null || _x === void 0 ? void 0 : _x.displayFreeze;
                if (((_y = config === null || config === void 0 ? void 0 : config.set) === null || _y === void 0 ? void 0 : _y.onlySetIfChanged) && value === this.state.displayFreeze.value) {
                    return value;
                }
                const newValue = yield this.setBoolean('displayFreeze', config, value, tags);
                return newValue !== null && newValue !== void 0 ? newValue : this.state.displayFreeze.value;
            }),
            isStateless: (config) => { var _a, _b, _c; return ((_c = (_b = (_a = config === null || config === void 0 ? void 0 : config.userDriver) === null || _a === void 0 ? void 0 : _a.controls) === null || _b === void 0 ? void 0 : _b.displayFreeze) === null || _c === void 0 ? void 0 : _c.get) === undefined; },
            isToggle: (config) => { var _a, _b, _c; return ((_c = (_b = (_a = config === null || config === void 0 ? void 0 : config.userDriver) === null || _a === void 0 ? void 0 : _a.controls) === null || _b === void 0 ? void 0 : _b.displayFreeze) === null || _c === void 0 ? void 0 : _c.isToggle) === true; },
            hasControl: (config) => __awaiter(this, void 0, void 0, function* () { var _z, _0; return ((_0 = (_z = config === null || config === void 0 ? void 0 : config.userDriver) === null || _z === void 0 ? void 0 : _z.controls) === null || _0 === void 0 ? void 0 : _0.displayFreeze) !== undefined; }),
            powerOffRestrictions: (config) => { var _a, _b; return this.computePowerOffRestrictions((_b = (_a = config.userDriver) === null || _a === void 0 ? void 0 : _a.controls) === null || _b === void 0 ? void 0 : _b.displayFreeze); },
        };
        this.firmwareVersion = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                var _1, _2, _3;
                const value = yield this.getString('firmwareVersion', (_3 = (_2 = (_1 = this.config) === null || _1 === void 0 ? void 0 : _1.userDriver) === null || _2 === void 0 ? void 0 : _2.controls) === null || _3 === void 0 ? void 0 : _3.firmwareVersion, tags);
                return value !== null && value !== void 0 ? value : 'unknown';
            }),
            hasControl: (config) => __awaiter(this, void 0, void 0, function* () { var _4, _5; return ((_5 = (_4 = config === null || config === void 0 ? void 0 : config.userDriver) === null || _4 === void 0 ? void 0 : _4.controls) === null || _5 === void 0 ? void 0 : _5.firmwareVersion) !== undefined; }),
            powerOffRestrictions: (config) => { var _a, _b; return this.computePowerOffRestrictions((_b = (_a = config.userDriver) === null || _a === void 0 ? void 0 : _a.controls) === null || _b === void 0 ? void 0 : _b.firmwareVersion); },
        };
        this.mute = {
            get: (key, tags) => __awaiter(this, void 0, void 0, function* () {
                var _6;
                if (key === this.volumeMuteKey)
                    return false;
                const config = this.getAudioMuteConfig(key);
                if (config === undefined) {
                    this.log.error(`no mute config for "${key}"`);
                    return false;
                }
                const value = yield this.getBoolean('mute', config, tags, { key });
                return (_6 = value !== null && value !== void 0 ? value : this.state.mutes.values[key]) !== null && _6 !== void 0 ? _6 : false;
            }),
            set: (key, value, tags) => __awaiter(this, void 0, void 0, function* () {
                var _7;
                if (key === this.volumeMuteKey)
                    return false;
                const config = this.getAudioMuteConfig(key);
                if (config === undefined) {
                    this.log.error(`no mute config for "${key}"`);
                    return false;
                }
                const newValue = yield this.setBoolean('mute', config, value, tags, { key });
                return (_7 = newValue !== null && newValue !== void 0 ? newValue : this.state.mutes.values[key]) !== null && _7 !== void 0 ? _7 : false;
            }),
            getKey: (config) => {
                if (isUserDriverConfig(config))
                    return config;
                throw new Error(`invalid config: ${JSON.stringify(config)}`);
            },
            validate: (config, info) => __awaiter(this, void 0, void 0, function* () {
                if (!isUserDriverConfig(config)) {
                    this.log.error(`invalid config: ${JSON.stringify(config)}`);
                    return 'incompatible';
                }
                return this.validateAudio(config, info.filter);
            }),
            hasControl: (config) => __awaiter(this, void 0, void 0, function* () { var _8, _9; return ((_9 = (_8 = config === null || config === void 0 ? void 0 : config.userDriver) === null || _8 === void 0 ? void 0 : _8.controls) === null || _9 === void 0 ? void 0 : _9.audio) !== undefined; }),
        };
        this.power = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                var _10, _11, _12;
                const value = yield this.getBoolean('power', (_12 = (_11 = (_10 = this.config) === null || _10 === void 0 ? void 0 : _10.userDriver) === null || _11 === void 0 ? void 0 : _11.controls) === null || _12 === void 0 ? void 0 : _12.power, tags);
                return value !== null && value !== void 0 ? value : false;
            }),
            set: (value, tags) => __awaiter(this, void 0, void 0, function* () {
                var _13, _14, _15, _16;
                const config = (_15 = (_14 = (_13 = this.config) === null || _13 === void 0 ? void 0 : _13.userDriver) === null || _14 === void 0 ? void 0 : _14.controls) === null || _15 === void 0 ? void 0 : _15.power;
                if (((_16 = config === null || config === void 0 ? void 0 : config.set) === null || _16 === void 0 ? void 0 : _16.onlySetIfChanged) && value === this.state.power.value) {
                    return value;
                }
                const newValue = yield this.setBoolean('power', config, value, tags);
                return newValue !== null && newValue !== void 0 ? newValue : this.state.power.value;
            }),
            isStateless: (config) => { var _a, _b, _c; return ((_c = (_b = (_a = config === null || config === void 0 ? void 0 : config.userDriver) === null || _a === void 0 ? void 0 : _a.controls) === null || _b === void 0 ? void 0 : _b.power) === null || _c === void 0 ? void 0 : _c.get) === undefined; },
            isToggle: (config) => { var _a, _b, _c; return ((_c = (_b = (_a = config === null || config === void 0 ? void 0 : config.userDriver) === null || _a === void 0 ? void 0 : _a.controls) === null || _b === void 0 ? void 0 : _b.power) === null || _c === void 0 ? void 0 : _c.isToggle) === true; },
            hasControl: (config) => __awaiter(this, void 0, void 0, function* () { var _17, _18; return ((_18 = (_17 = config === null || config === void 0 ? void 0 : config.userDriver) === null || _17 === void 0 ? void 0 : _17.controls) === null || _18 === void 0 ? void 0 : _18.power) !== undefined; }),
            powerOffRestrictions: (config) => { var _a, _b; return this.computePowerOffRestrictions((_b = (_a = config.userDriver) === null || _a === void 0 ? void 0 : _a.controls) === null || _b === void 0 ? void 0 : _b.power); },
        };
        this.serialNumber = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                var _19, _20, _21;
                const value = yield this.getString('serialNumber', (_21 = (_20 = (_19 = this.config) === null || _19 === void 0 ? void 0 : _19.userDriver) === null || _20 === void 0 ? void 0 : _20.controls) === null || _21 === void 0 ? void 0 : _21.serialNumber, tags);
                return value !== null && value !== void 0 ? value : 'unknown';
            }),
            hasControl: (config) => __awaiter(this, void 0, void 0, function* () { var _22, _23; return ((_23 = (_22 = config === null || config === void 0 ? void 0 : config.userDriver) === null || _22 === void 0 ? void 0 : _22.controls) === null || _23 === void 0 ? void 0 : _23.serialNumber) !== undefined; }),
            powerOffRestrictions: (config) => { var _a, _b; return this.computePowerOffRestrictions((_b = (_a = config.userDriver) === null || _a === void 0 ? void 0 : _a.controls) === null || _b === void 0 ? void 0 : _b.serialNumber); },
        };
        this.telephony = {
            answer: (key) => __awaiter(this, void 0, void 0, function* () {
                this.log.error(`answer not supported in user drivers`);
                return false;
            }),
            call: (value) => __awaiter(this, void 0, void 0, function* () {
                var _24, _25, _26, _27;
                yield this.setString('telephony.call', (_27 = (_26 = (_25 = (_24 = this.config) === null || _24 === void 0 ? void 0 : _24.userDriver) === null || _25 === void 0 ? void 0 : _25.controls) === null || _26 === void 0 ? void 0 : _26.telephony) === null || _27 === void 0 ? void 0 : _27.call, value.dialString, ['call.set'], { call: Object.assign({}, value) });
                return undefined;
            }),
            getCalls: () => __awaiter(this, void 0, void 0, function* () {
                return {};
            }),
            getMaxCalls: () => __awaiter(this, void 0, void 0, function* () {
                var _28, _29, _30, _31, _32;
                return (_32 = (_31 = (_30 = (_29 = (_28 = this.config) === null || _28 === void 0 ? void 0 : _28.userDriver) === null || _29 === void 0 ? void 0 : _29.controls) === null || _30 === void 0 ? void 0 : _30.telephony) === null || _31 === void 0 ? void 0 : _31.maxCalls) !== null && _32 !== void 0 ? _32 : {};
            }),
            hangup: (key) => __awaiter(this, void 0, void 0, function* () {
                this.log.error(`hangup not supported in user drivers`);
                return false;
            }),
            reject: (key) => __awaiter(this, void 0, void 0, function* () {
                this.log.error(`reject not supported in user drivers`);
                return false;
            }),
            hasControl: (config) => __awaiter(this, void 0, void 0, function* () { var _33, _34; return ((_34 = (_33 = config === null || config === void 0 ? void 0 : config.userDriver) === null || _33 === void 0 ? void 0 : _33.controls) === null || _34 === void 0 ? void 0 : _34.telephony) !== undefined; }),
        };
        this.usbHost = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                var _35, _36, _37;
                const value = yield this.getString('usbHost', (_37 = (_36 = (_35 = this.config) === null || _35 === void 0 ? void 0 : _35.userDriver) === null || _36 === void 0 ? void 0 : _36.controls) === null || _37 === void 0 ? void 0 : _37.usbHost, tags);
                return value !== null && value !== void 0 ? value : 'unknown';
            }),
            set: (value, tags) => __awaiter(this, void 0, void 0, function* () {
                var _38, _39, _40, _41;
                const config = (_40 = (_39 = (_38 = this.config) === null || _38 === void 0 ? void 0 : _38.userDriver) === null || _39 === void 0 ? void 0 : _39.controls) === null || _40 === void 0 ? void 0 : _40.usbHost;
                if (((_41 = config === null || config === void 0 ? void 0 : config.set) === null || _41 === void 0 ? void 0 : _41.onlySetIfChanged) && value === this.state.usbHost.value) {
                    return value;
                }
                const newValue = yield this.setString('usbHost', config, value, tags);
                return newValue !== null && newValue !== void 0 ? newValue : this.state.usbHost.value;
            }),
            isStateless: (config) => { var _a, _b, _c; return ((_c = (_b = (_a = config === null || config === void 0 ? void 0 : config.userDriver) === null || _a === void 0 ? void 0 : _a.controls) === null || _b === void 0 ? void 0 : _b.usbHost) === null || _c === void 0 ? void 0 : _c.get) === undefined; },
            hasControl: (config) => __awaiter(this, void 0, void 0, function* () { var _42, _43; return ((_43 = (_42 = config === null || config === void 0 ? void 0 : config.userDriver) === null || _42 === void 0 ? void 0 : _42.controls) === null || _43 === void 0 ? void 0 : _43.usbHost) !== undefined; }),
            powerOffRestrictions: (config) => { var _a, _b; return this.computePowerOffRestrictions((_b = (_a = config.userDriver) === null || _a === void 0 ? void 0 : _a.controls) === null || _b === void 0 ? void 0 : _b.usbHost); },
        };
        this.videoInput = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                var _44, _45, _46;
                const value = yield this.getString('videoInput', (_46 = (_45 = (_44 = this.config) === null || _44 === void 0 ? void 0 : _44.userDriver) === null || _45 === void 0 ? void 0 : _45.controls) === null || _46 === void 0 ? void 0 : _46.videoInput, tags);
                return value !== null && value !== void 0 ? value : 'unknown';
            }),
            set: (value, tags) => __awaiter(this, void 0, void 0, function* () {
                var _47, _48, _49, _50;
                const config = (_49 = (_48 = (_47 = this.config) === null || _47 === void 0 ? void 0 : _47.userDriver) === null || _48 === void 0 ? void 0 : _48.controls) === null || _49 === void 0 ? void 0 : _49.videoInput;
                if (((_50 = config === null || config === void 0 ? void 0 : config.set) === null || _50 === void 0 ? void 0 : _50.onlySetIfChanged) && value === this.state.videoInput.value) {
                    return value;
                }
                const newValue = yield this.setString('videoInput', config, value, tags);
                return newValue !== null && newValue !== void 0 ? newValue : this.state.videoInput.value;
            }),
            isStateless: (config) => { var _a, _b, _c; return ((_c = (_b = (_a = config === null || config === void 0 ? void 0 : config.userDriver) === null || _a === void 0 ? void 0 : _a.controls) === null || _b === void 0 ? void 0 : _b.videoInput) === null || _c === void 0 ? void 0 : _c.get) === undefined; },
            hasControl: (config) => __awaiter(this, void 0, void 0, function* () { var _51, _52; return ((_52 = (_51 = config === null || config === void 0 ? void 0 : config.userDriver) === null || _51 === void 0 ? void 0 : _51.controls) === null || _52 === void 0 ? void 0 : _52.videoInput) !== undefined; }),
            powerOffRestrictions: (config) => { var _a, _b; return this.computePowerOffRestrictions((_b = (_a = config.userDriver) === null || _a === void 0 ? void 0 : _a.controls) === null || _b === void 0 ? void 0 : _b.videoInput); },
        };
        this.videoMatrixRoutes = {
            get: (key, tags) => __awaiter(this, void 0, void 0, function* () {
                var _53, _54, _55, _56;
                const config = (_55 = (_54 = (_53 = this.config) === null || _53 === void 0 ? void 0 : _53.userDriver) === null || _54 === void 0 ? void 0 : _54.controls) === null || _55 === void 0 ? void 0 : _55.videoMatrixRoutes;
                const output = this.formatString(key, (_56 = config === null || config === void 0 ? void 0 : config.set) === null || _56 === void 0 ? void 0 : _56.format);
                const value = yield this.getString('videoMatrixRoutes', config, tags, { output });
                return value !== null && value !== void 0 ? value : 'unknown';
            }),
            set: (key, value, tags) => __awaiter(this, void 0, void 0, function* () {
                var _57, _58, _59, _60, _61, _62;
                const config = (_59 = (_58 = (_57 = this.config) === null || _57 === void 0 ? void 0 : _57.userDriver) === null || _58 === void 0 ? void 0 : _58.controls) === null || _59 === void 0 ? void 0 : _59.videoMatrixRoutes;
                if (((_60 = config === null || config === void 0 ? void 0 : config.set) === null || _60 === void 0 ? void 0 : _60.onlySetIfChanged) &&
                    this.state.videoMatrixRoutes.values[key] === value) {
                    return value;
                }
                const output = this.formatString(key, (_61 = config === null || config === void 0 ? void 0 : config.set) === null || _61 === void 0 ? void 0 : _61.format);
                const newValue = yield this.setString('videoMatrixRoutes', config, value, tags, {
                    output,
                });
                return (_62 = newValue !== null && newValue !== void 0 ? newValue : this.state.videoMatrixRoutes.values[key]) !== null && _62 !== void 0 ? _62 : 'unknown';
            }),
            isStateless: (config) => { var _a, _b, _c; return ((_c = (_b = (_a = config === null || config === void 0 ? void 0 : config.userDriver) === null || _a === void 0 ? void 0 : _a.controls) === null || _b === void 0 ? void 0 : _b.videoMatrixRoutes) === null || _c === void 0 ? void 0 : _c.get) === undefined; },
            hasControl: (config) => __awaiter(this, void 0, void 0, function* () { var _63, _64; return ((_64 = (_63 = config === null || config === void 0 ? void 0 : config.userDriver) === null || _63 === void 0 ? void 0 : _63.controls) === null || _64 === void 0 ? void 0 : _64.videoMatrixRoutes) !== undefined; }),
            powerOffRestrictions: (config) => { var _a, _b; return this.computePowerOffRestrictions((_b = (_a = config.userDriver) === null || _a === void 0 ? void 0 : _a.controls) === null || _b === void 0 ? void 0 : _b.videoMatrixRoutes); },
        };
        this.volume = {
            get: (key, tags) => __awaiter(this, void 0, void 0, function* () {
                var _65;
                const config = this.getAudioVolumeConfig(key);
                if (config === undefined) {
                    this.log.error(`no volume config for "${key}"`);
                    return 0;
                }
                const value = yield this.getNumber('volume', config, tags, { key });
                return (_65 = value !== null && value !== void 0 ? value : this.state.volumes.values[key]) !== null && _65 !== void 0 ? _65 : 0;
            }),
            set: (key, value, tags) => __awaiter(this, void 0, void 0, function* () {
                var _66;
                const config = this.getAudioVolumeConfig(key);
                if (config === undefined) {
                    this.log.error(`no volume config for "${key}"`);
                    return 0;
                }
                const newValue = yield this.setNumber('volume', config, value, tags, { key });
                return (_66 = newValue !== null && newValue !== void 0 ? newValue : this.state.volumes.values[key]) !== null && _66 !== void 0 ? _66 : 0;
            }),
            getKey: (config) => {
                if (isUserDriverConfig(config))
                    return config;
                throw new Error(`invalid config: ${JSON.stringify(config)}`);
            },
            range: (config, info) => __awaiter(this, void 0, void 0, function* () {
                var _67, _68, _69, _70, _71, _72, _73;
                if (!isUserDriverConfig(config)) {
                    this.log.error(`invalid config`);
                    return defaultVolumeRanges[info.volumeType];
                }
                const ranges = (_72 = (_71 = (_70 = (_69 = (_68 = (_67 = this.config) === null || _67 === void 0 ? void 0 : _67.userDriver) === null || _68 === void 0 ? void 0 : _68.controls) === null || _69 === void 0 ? void 0 : _69.audio) === null || _70 === void 0 ? void 0 : _70.volume) === null || _71 === void 0 ? void 0 : _71.range) !== null && _72 !== void 0 ? _72 : [];
                const range = ranges.find(r => {
                    return r.keys === undefined || r.keys.includes(config);
                });
                return (_73 = range === null || range === void 0 ? void 0 : range[info.volumeType]) !== null && _73 !== void 0 ? _73 : defaultVolumeRanges[info.volumeType];
            }),
            validate: (config, info) => __awaiter(this, void 0, void 0, function* () {
                if (!isUserDriverConfig(config)) {
                    this.log.error(`invalid config: ${JSON.stringify(config)}`);
                    return 'incompatible';
                }
                if (info.filter === 'amplifier')
                    this.volumeMuteKey = config;
                return this.validateAudio(config, info.filter);
            }),
            hasControl: (config) => __awaiter(this, void 0, void 0, function* () { var _74, _75; return ((_75 = (_74 = config === null || config === void 0 ? void 0 : config.userDriver) === null || _74 === void 0 ? void 0 : _74.controls) === null || _75 === void 0 ? void 0 : _75.audio) !== undefined; }),
        };
        // polling
        this.polls = [];
    }
    // phase callbacks
    onBeforeConfigure(config) {
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.clearAll();
            // We have to assign the config here in onBeforeConfigure because it is used in the control
            // get functions.
            this.config = config;
        });
    }
    onConfigure(config) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.clearAll();
            this.asts = {};
            this.volumeMuteKey = undefined;
            this.polls.length = 0;
            const controls = ((_b = (_a = config.userDriver) === null || _a === void 0 ? void 0 : _a.controls) !== null && _b !== void 0 ? _b : {});
            const defaultPollMs = (_d = (_c = config.userDriver) === null || _c === void 0 ? void 0 : _c.pollMs) !== null && _d !== void 0 ? _d : 4000;
            this.addNormalPollDefs(this.polls, controls, defaultPollMs);
            this.addAudioPollDefs(config, this.polls, defaultPollMs);
            if ((_h = (_g = (_f = (_e = config.userDriver) === null || _e === void 0 ? void 0 : _e.controls) === null || _f === void 0 ? void 0 : _f.ping) === null || _g === void 0 ? void 0 : _g.set) === null || _h === void 0 ? void 0 : _h.poll) {
                const cmd = config.userDriver.controls.ping.set.send;
                this.polls.push({
                    function: () => __awaiter(this, void 0, void 0, function* () {
                        if (typeof cmd === 'string') {
                            yield this.socket.sendAsync(cmd, ['get.ping', 'poll']);
                        }
                        else {
                            if (!isRequestMethod(cmd.method)) {
                                throw new Error(`invalid request method "${cmd.method}" in initializer step`);
                            }
                            yield this.request({
                                method: cmd.method,
                                path: cmd.path,
                                options: {
                                    headers: cmd.headers,
                                    serializer: cmd.serializer,
                                },
                            }, ['get.ping', 'poll']);
                        }
                    }),
                    intervalMs: (_j = config.userDriver.controls.ping.set.pollMs) !== null && _j !== void 0 ? _j : defaultPollMs,
                });
            }
        });
    }
    onDisconnect() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.clearAll();
            (_a = this.httpRequest) === null || _a === void 0 ? void 0 : _a.close();
        });
    }
    onInitialize(credentials, config) {
        var _a, _b, _c, _d;
        return __awaiter(this, void 0, void 0, function* () {
            if (((_a = config.userDriver) === null || _a === void 0 ? void 0 : _a.httpRequestOptions) !== undefined) {
                this.httpRequest = yield this.framework.createHttpRequest((_b = config.ipAddress) !== null && _b !== void 0 ? _b : '', config.userDriver.httpRequestOptions);
            }
            if ((_c = config.userDriver) === null || _c === void 0 ? void 0 : _c.initializerSteps) {
                const steps = this.convertInitializerSteps(credentials, getValuesSortedByKey(config.userDriver.initializerSteps));
                const result = yield CommandSocketInitializer.initialize(this.socket, steps, credentials);
                if (result !== 'connected')
                    return result;
            }
            if ((_d = config.userDriver) === null || _d === void 0 ? void 0 : _d.httpInitializerSteps) {
                return yield this.httpInitialize(config.userDriver.httpInitializerSteps, credentials);
            }
            return 'connected';
        });
    }
    // other class methods
    addAudioPollDefs(config, polls, defaultPollMs) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x;
        const mutes = (_e = (_d = (_c = (_b = (_a = config.userDriver) === null || _a === void 0 ? void 0 : _a.controls) === null || _b === void 0 ? void 0 : _b.audio) === null || _c === void 0 ? void 0 : _c.mute) === null || _d === void 0 ? void 0 : _d.get) !== null && _e !== void 0 ? _e : [];
        const volumes = (_k = (_j = (_h = (_g = (_f = config.userDriver) === null || _f === void 0 ? void 0 : _f.controls) === null || _g === void 0 ? void 0 : _g.audio) === null || _h === void 0 ? void 0 : _h.volume) === null || _j === void 0 ? void 0 : _j.get) !== null && _k !== void 0 ? _k : [];
        for (const mute of mutes) {
            if (!mute.poll)
                continue;
            const keys = (_q = (_l = mute.keys) !== null && _l !== void 0 ? _l : (_p = (_o = (_m = config.userDriver) === null || _m === void 0 ? void 0 : _m.controls) === null || _o === void 0 ? void 0 : _o.audio) === null || _p === void 0 ? void 0 : _p.channels.map(chan => chan.key)) !== null && _q !== void 0 ? _q : [];
            polls.push({
                function: () => __awaiter(this, void 0, void 0, function* () {
                    for (const key of keys) {
                        if (this.state.mutes.values[key] === undefined)
                            continue;
                        const config = this.getAudioMuteConfig(key);
                        const value = yield this.getBoolean('mute', config, [`get.mute.${key}`, 'poll'], { key });
                        if (value !== undefined)
                            this.state.mutes.update(key, value);
                    }
                }),
                intervalMs: (_r = mute.pollMs) !== null && _r !== void 0 ? _r : defaultPollMs,
            });
        }
        for (const volume of volumes) {
            if (!volume.poll)
                continue;
            const keys = (_w = (_s = volume.keys) !== null && _s !== void 0 ? _s : (_v = (_u = (_t = config.userDriver) === null || _t === void 0 ? void 0 : _t.controls) === null || _u === void 0 ? void 0 : _u.audio) === null || _v === void 0 ? void 0 : _v.channels.map(chan => chan.key)) !== null && _w !== void 0 ? _w : [];
            polls.push({
                function: () => __awaiter(this, void 0, void 0, function* () {
                    for (const key of keys) {
                        if (this.state.volumes.values[key] === undefined)
                            continue;
                        const config = this.getAudioVolumeConfig(key);
                        const value = yield this.getNumber('volume', config, [`get.volume.${key}`, 'poll'], { key });
                        if (value !== undefined)
                            this.state.volumes.update(key, value);
                    }
                }),
                intervalMs: (_x = volume.pollMs) !== null && _x !== void 0 ? _x : defaultPollMs,
            });
        }
    }
    addNormalPollDefs(polls, controls, defaultPollMs) {
        var _a, _b, _c;
        for (const name of pollableControlNames) {
            const get = (_a = controls[name]) === null || _a === void 0 ? void 0 : _a.get;
            if (get === undefined || !((_b = get.poll) !== null && _b !== void 0 ? _b : false))
                continue;
            const pollMs = (_c = get.pollMs) !== null && _c !== void 0 ? _c : defaultPollMs;
            let pollDef = polls.find(def => 'controls' in def && def.intervalMs === pollMs);
            if (pollDef === undefined) {
                pollDef = { controls: [], intervalMs: pollMs };
                polls.push(pollDef);
            }
            pollDef.controls.push(name);
        }
    }
    computePowerOffRestrictions(control) {
        var _a, _b;
        const powerOffRestrictions = [];
        if ((_a = control === null || control === void 0 ? void 0 : control.get) === null || _a === void 0 ? void 0 : _a.powerOffRestriction)
            powerOffRestrictions.push('get');
        if ((_b = control === null || control === void 0 ? void 0 : control.set) === null || _b === void 0 ? void 0 : _b.powerOffRestriction)
            powerOffRestrictions.push('set');
        return powerOffRestrictions;
    }
    convertInitializerStep(credentials, userStep) {
        const step = { errorCode: userStep.errorCode };
        if (userStep.raw !== undefined)
            step.raw = userStep.raw;
        if (userStep.timeoutMs !== undefined)
            step.timeoutMs = userStep.timeoutMs;
        if (userStep.send !== undefined) {
            try {
                step.send = this.interpolate(userStep.send, credentials);
            }
            catch (error) {
                throw new UserDriverError(`error evaluating initializer step send string: "${userStep.send}"`);
            }
        }
        if (userStep.succeed !== undefined) {
            step.succeed = createRegExp('initializer step succeed', {
                ignoreCase: userStep.succeed.ignoreCase,
                value: this.interpolate(userStep.succeed.value, credentials),
            });
        }
        if (userStep.unterminatedRegExp !== undefined) {
            step.unterminatedRegExp = createRegExp('initializer step unterminatedRegExp', {
                ignoreCase: userStep.unterminatedRegExp.ignoreCase,
                value: this.interpolate(userStep.unterminatedRegExp.value, credentials),
            });
        }
        if (userStep.fail !== undefined) {
            step.fail = createRegExp('initializer step fail', {
                ignoreCase: userStep.fail.ignoreCase,
                value: this.interpolate(userStep.fail.value, credentials),
            });
        }
        if (userStep.next !== undefined) {
            step.next = createRegExp('initializer step next', {
                ignoreCase: userStep.next.ignoreCase,
                value: this.interpolate(userStep.next.value, credentials),
            });
        }
        return step;
    }
    convertInitializerSteps(credentials, userSteps) {
        return userSteps.map(step => this.convertInitializerStep(credentials, step));
    }
    formatBoolean(value, format) {
        var _a, _b;
        if (format === undefined)
            format = { type: 'decimal' };
        if (format.type === 'decimal') {
            if (format.invert)
                value = !value;
            let valueFmt = (value ? 1 : 0).toString();
            if (format.length !== undefined) {
                if (format.justify === 'left') {
                    valueFmt = valueFmt.padEnd(format.length, (_a = format.padValue) !== null && _a !== void 0 ? _a : ' ');
                }
                else {
                    valueFmt = valueFmt.padStart(format.length, (_b = format.padValue) !== null && _b !== void 0 ? _b : ' ');
                }
            }
            return valueFmt;
        }
        else if (format.type === 'string') {
            return value ? format.true : format.false;
        }
        return '';
    }
    formatNumber(value, format) {
        var _a, _b;
        if (format === undefined)
            format = { type: 'decimal' };
        let valueStr = '';
        if (format.type === 'decimal') {
            valueStr = value.toString();
        }
        else if (format.type === 'fixed') {
            valueStr = value.toFixed(format.precision);
        }
        else if (format.type === 'hex') {
            valueStr = value.toString(16);
            if (format.lowerCase)
                valueStr = valueStr.toLowerCase();
        }
        if (format.map !== undefined) {
            valueStr = (_a = format.map[valueStr]) !== null && _a !== void 0 ? _a : valueStr;
        }
        if (format.length === undefined)
            return valueStr;
        return valueStr.padStart(format.length, (_b = format.padValue) !== null && _b !== void 0 ? _b : '0');
    }
    formatString(value, format) {
        var _a, _b, _c;
        if (format === undefined)
            format = { type: 'string' };
        if (format.length !== undefined) {
            if (format.justify === 'left') {
                value = value.padEnd(format.length, (_a = format.padValue) !== null && _a !== void 0 ? _a : ' ');
            }
            else {
                value = value.padStart(format.length, (_b = format.padValue) !== null && _b !== void 0 ? _b : ' ');
            }
        }
        if (format.map !== undefined) {
            value = (_c = format.map[value]) !== null && _c !== void 0 ? _c : value;
        }
        return value;
    }
    getAudioChannel(key) {
        var _a, _b, _c, _d, _e;
        const channels = (_e = (_d = (_c = (_b = (_a = this.config) === null || _a === void 0 ? void 0 : _a.userDriver) === null || _b === void 0 ? void 0 : _b.controls) === null || _c === void 0 ? void 0 : _c.audio) === null || _d === void 0 ? void 0 : _d.channels) !== null && _e !== void 0 ? _e : [];
        return channels.find(channel => channel.key === key);
    }
    getAudioMuteConfig(key) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        const muteGetControls = (_f = (_e = (_d = (_c = (_b = (_a = this.config) === null || _a === void 0 ? void 0 : _a.userDriver) === null || _b === void 0 ? void 0 : _b.controls) === null || _c === void 0 ? void 0 : _c.audio) === null || _d === void 0 ? void 0 : _d.mute) === null || _e === void 0 ? void 0 : _e.get) !== null && _f !== void 0 ? _f : [];
        const controlGet = muteGetControls.find(ctrl => ctrl.keys === undefined || ctrl.keys.includes(key));
        const muteSetControls = (_m = (_l = (_k = (_j = (_h = (_g = this.config) === null || _g === void 0 ? void 0 : _g.userDriver) === null || _h === void 0 ? void 0 : _h.controls) === null || _j === void 0 ? void 0 : _j.audio) === null || _k === void 0 ? void 0 : _k.mute) === null || _l === void 0 ? void 0 : _l.set) !== null && _m !== void 0 ? _m : [];
        const controlSet = muteSetControls.find(ctrl => ctrl.keys === undefined || ctrl.keys.includes(key));
        return { get: controlGet, set: controlSet };
    }
    getAudioVolumeConfig(key) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        const volumeGetControls = (_f = (_e = (_d = (_c = (_b = (_a = this.config) === null || _a === void 0 ? void 0 : _a.userDriver) === null || _b === void 0 ? void 0 : _b.controls) === null || _c === void 0 ? void 0 : _c.audio) === null || _d === void 0 ? void 0 : _d.volume) === null || _e === void 0 ? void 0 : _e.get) !== null && _f !== void 0 ? _f : [];
        const controlGet = volumeGetControls.find(ctrl => ctrl.keys === undefined || ctrl.keys.includes(key));
        const volumeSetControls = (_m = (_l = (_k = (_j = (_h = (_g = this.config) === null || _g === void 0 ? void 0 : _g.userDriver) === null || _h === void 0 ? void 0 : _h.controls) === null || _j === void 0 ? void 0 : _j.audio) === null || _k === void 0 ? void 0 : _k.volume) === null || _l === void 0 ? void 0 : _l.set) !== null && _m !== void 0 ? _m : [];
        const controlSet = volumeSetControls.find(ctrl => ctrl.keys === undefined || ctrl.keys.includes(key));
        return { get: controlGet, set: controlSet };
    }
    getBoolean(control, config, tags, scope) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.getValue(control, config, tags, this.parseBoolean, scope);
        });
    }
    getNumber(control, config, tags, scope) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.getValue(control, config, tags, this.parseNumber, scope);
        });
    }
    getString(control, config, tags, scope) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.getValue(control, config, tags, this.parseString, scope);
        });
    }
    getValue(control, config, tags, parse, scope = {}) {
        var _a, _b, _c, _d, _e, _f;
        return __awaiter(this, void 0, void 0, function* () {
            if (config === undefined)
                throw new Error(`no config for ${control} control`);
            if (config.get === undefined)
                throw new Error(`no get config for ${control} control`);
            let cmd;
            if (typeof config.get.send === 'string') {
                try {
                    cmd = this.interpolate(config.get.send, scope, `${control}.get.send`);
                }
                catch (error) {
                    throw new UserDriverError(`error evaluating ${control} get send string: "${config.get.send}"`);
                }
            }
            else {
                try {
                    cmd = this.interpolateHttp(config.get.send, scope, `${control}.get.send`);
                }
                catch (error) {
                    throw new UserDriverError(`error evaluationg ${control} get send request ${JSON.stringify(config.get.send)}`);
                }
            }
            const sendOptions = Object.assign(Object.assign({}, (((_b = (_a = config.get) === null || _a === void 0 ? void 0 : _a.match) === null || _b === void 0 ? void 0 : _b.sendTimeoutMs) === undefined
                ? undefined
                : { sendTimeoutMs: config.get.match.sendTimeoutMs })), (((_d = (_c = config.get) === null || _c === void 0 ? void 0 : _c.match) === null || _d === void 0 ? void 0 : _d.sendTimeoutRetryAttempts) === undefined
                ? undefined
                : { retryAttempts: config.get.match.sendTimeoutRetryAttempts }));
            const interpolatedRegExpValue = this.interpolate(config.get.match.regExp.value, scope, `${control}.get.match.regExp.value`);
            const interpolatedRegExp = Object.assign(Object.assign({}, config.get.match.regExp), { value: interpolatedRegExpValue });
            const regExp = createRegExp(`${control} get match`, interpolatedRegExp);
            let match;
            if (typeof cmd === 'string') {
                match = yield this.socket.send(cmd, regExp, tags, sendOptions);
            }
            else {
                match = yield this.request(cmd, tags, sendOptions, regExp);
            }
            const valueStr = match.find((m, i) => i > 0 && m !== undefined);
            if (valueStr === undefined) {
                throw new UserDriverError(`no match for ${control} set response`);
            }
            // TODO: handle retry
            if (config.get.match.error !== undefined) {
                let compareValue = valueStr;
                let errors = Array.isArray(config.get.match.error)
                    ? config.get.match.error
                    : [config.get.match.error];
                if (config.get.match.regExp.ignoreCase) {
                    errors = errors.map(e => e.toLowerCase());
                    compareValue = compareValue.toLowerCase();
                }
                if (errors.includes(compareValue))
                    return undefined;
            }
            return parse(valueStr, (_e = config.get.match.format) !== null && _e !== void 0 ? _e : (_f = config.set) === null || _f === void 0 ? void 0 : _f.format);
        });
    }
    httpConvertOptions(options, sendOptions = {}) {
        var _a;
        const converted = Object.assign({}, options);
        if (sendOptions.sendTimeoutMs !== undefined) {
            converted.timeoutMs = sendOptions.sendTimeoutMs;
        }
        if (((_a = converted.serializer) !== null && _a !== void 0 ? _a : 'json') === 'json' && typeof converted.data === 'string') {
            try {
                converted.data = JSON.parse(converted.data);
            }
            catch (_b) {
                this.log.error(`failed parsing JSON: ${JSON.stringify(options.data)}`);
            }
        }
        return converted;
    }
    httpInitialize(steps, credentials) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.httpRequest === undefined) {
                throw new Error(`httpRequest undefined; you probably forgot to specify httpRequestOptions`);
            }
            for (const step of getValuesSortedByKey(steps)) {
                const cmd = this.interpolateHttp(step.send, Object.assign({}, credentials));
                const options = this.httpConvertOptions(cmd.options);
                const resp = yield this.httpRequest.request(cmd.method, cmd.path, options);
                const result = JSON.stringify(resp);
                if (step.succeed &&
                    createRegExp('initializer step succeed', step.succeed).exec(result)) {
                    return 'connected';
                }
                if (step.next && createRegExp('initializer step next', step.next).exec(result)) {
                    continue;
                }
                if (step.fail && createRegExp('initializer step fail', step.fail).exec(result)) {
                    return step.errorCode;
                }
            }
            return 'connected';
        });
    }
    interpolate(str, scope, astKey) {
        var _a;
        let ast = undefined;
        if (astKey !== undefined) {
            ast = this.asts[astKey];
        }
        if (ast === undefined) {
            const parser = new Parser('`' + str + '`');
            try {
                ast = parser.parse();
            }
            catch (error) {
                let prefix = `error parsing expression`;
                if (astKey !== undefined)
                    prefix += ` for ${str}`;
                if (error instanceof ParseError || error.position !== undefined) {
                    this.log.error(`${prefix}: ${error.message} at position ${error.position}`);
                }
                else {
                    this.log.error(`${prefix}: ${error.message}`);
                }
            }
            if (ast !== undefined && astKey !== undefined) {
                this.asts[astKey] = ast;
            }
        }
        const scopeWithUtilityFunctions = Object.assign(Object.assign({}, scope), { String: {
                fromCharCode: (n) => {
                    if (typeof n === 'number')
                        return String.fromCharCode(n);
                    throw new Error(`argument to String.fromCharCode is not a number`);
                },
            } });
        return ((_a = ast === null || ast === void 0 ? void 0 : ast.evaluate(scopeWithUtilityFunctions)) !== null && _a !== void 0 ? _a : '').toString();
    }
    interpolateHttp(request, scope, astKey) {
        const method = this.interpolate(request.method, scope, astKey ? `${astKey}.method` : undefined);
        if (!isRequestMethod(method)) {
            throw new Error(`request method ${method} is not a valid request method`);
        }
        const path = this.interpolate(request.path, scope, astKey ? `${astKey}.path` : undefined);
        const options = {
            headers: request.headers,
            serializer: request.serializer,
        };
        if (request.data !== undefined) {
            options.data = this.interpolate(request.data, scope, astKey ? `${astKey}.data` : undefined);
        }
        if (request.params !== undefined) {
            const iparams = {};
            for (const [key, value] of Object.entries(request.params)) {
                iparams[key] = this.interpolate(value, scope, astKey ? `${astKey}.params.${key}` : undefined);
            }
            options.params = iparams;
        }
        return { method, path, options };
    }
    parseBoolean(value, format) {
        if (format === undefined)
            format = { type: 'decimal' };
        if (format.type === 'decimal') {
            const num = parseInt(value, 10);
            return num === (format.invert ? 0 : 1);
        }
        else if (format.type === 'string') {
            return value === format.true;
        }
        return false;
    }
    parseNumber(value, format) {
        var _a;
        if (format === undefined)
            format = { type: 'decimal' };
        let valueNum = 0;
        if (format.length !== undefined) {
            const padValue = (_a = format.padValue) !== null && _a !== void 0 ? _a : ' ';
            let unpaddedValue = '0';
            for (let i = 0; i < value.length; i++) {
                if (value.charAt(i) !== padValue) {
                    unpaddedValue = value.slice(i);
                }
            }
            value = unpaddedValue;
        }
        if (format.type === 'decimal' || format.type === 'fixed') {
            valueNum = parseFloat(value);
        }
        else if (format.type === 'hex') {
            valueNum = parseInt(value, 16);
        }
        return valueNum;
    }
    parseString(value, format) {
        var _a;
        if (format === undefined)
            format = { type: 'string' };
        if (format.length !== undefined) {
            const padValue = (_a = format.padValue) !== null && _a !== void 0 ? _a : ' ';
            if (format.justify === 'left') {
                for (let i = value.length - 1; i >= 0; i--) {
                    if (value.charAt(i) !== padValue) {
                        value = value.slice(0, i);
                    }
                }
            }
            else {
                for (let i = 0; i < value.length; i++) {
                    if (value.charAt(i) !== padValue) {
                        value = value.slice(i);
                    }
                }
            }
        }
        if (format.map !== undefined) {
            for (const [driverValue, deviceValue] of Object.entries(format.map)) {
                if (value === deviceValue) {
                    value = driverValue;
                    break;
                }
            }
        }
        return value;
    }
    request(cmd, tags, sendOptions = {}, regExp = /.*/) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.httpRequest === undefined) {
                throw new Error(`httpRequest undefined; you probably forgot to specify httpRequestOptions`);
            }
            const options = this.httpConvertOptions(cmd.options, sendOptions);
            const resp = JSON.stringify(yield this.httpRequest.request(cmd.method, cmd.path, options));
            const regExpResp = regExp.exec(resp);
            if (!regExpResp) {
                throw new TransportError(`http request didn't match`, 'commandFailed');
            }
            return regExpResp;
        });
    }
    setBoolean(control, config, value, tags, scope) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.setValue(control, config, value, tags, this.formatBoolean, this.parseBoolean, scope);
        });
    }
    setNumber(control, config, value, tags, scope) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.setValue(control, config, value, tags, this.formatNumber, this.parseNumber, scope);
        });
    }
    setString(control, config, value, tags, scope) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.setValue(control, config, value, tags, this.formatString, this.parseString, scope);
        });
    }
    setValue(control, config, value, tags, format, parse, scope = {}) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function* () {
            if (config === undefined)
                throw new Error(`no config for ${control} control`);
            if (config.set === undefined)
                throw new Error(`no set config for ${control} control`);
            const valueFmt = format(value, config.set.format);
            const busyMs = config.set.busyMs === undefined || typeof config.set.busyMs === 'number'
                ? config.set.busyMs
                : (_a = Object.values(config.set.busyMs).find(map => map.key === valueFmt)) === null || _a === void 0 ? void 0 : _a.value;
            if (busyMs !== undefined)
                this.state.busy.update(true);
            let cmd;
            if (typeof config.set.send === 'string') {
                try {
                    cmd = this.interpolate(config.set.send, Object.assign({ value: valueFmt }, scope), `${control}.set.send`);
                }
                catch (error) {
                    if (busyMs !== undefined)
                        this.state.busy.update(false);
                    throw new UserDriverError(`error evaluating ${control} set send string: "${config.set.send}"`);
                }
            }
            else {
                try {
                    cmd = this.interpolateHttp(config.set.send, Object.assign({ value: valueFmt }, scope), `${control}.set.send`);
                }
                catch (error) {
                    if (busyMs !== undefined)
                        this.state.busy.update(false);
                    throw new UserDriverError(`error evaluating ${control} set send request: ${JSON.stringify(config.set.send)}`);
                }
            }
            let returnValue;
            if (config.set.match === undefined) {
                if (typeof cmd === 'string') {
                    yield this.socket.sendAsync(cmd, tags);
                }
                else {
                    yield this.request(cmd, tags);
                }
            }
            else {
                const sendOptions = Object.assign(Object.assign({}, (config.set.match.sendTimeoutMs === undefined
                    ? undefined
                    : { sendTimeoutMs: config.set.match.sendTimeoutMs })), (config.set.match.sendTimeoutRetryAttempts === undefined
                    ? undefined
                    : { retryAttempts: config.set.match.sendTimeoutRetryAttempts }));
                const interpolatedRegExpValue = this.interpolate(config.set.match.regExp.value, scope, `${control}.set.match.regExp.value`);
                const interpolatedRegExp = Object.assign(Object.assign({}, config.set.match.regExp), { value: interpolatedRegExpValue });
                const regExp = createRegExp(`${control} set match`, interpolatedRegExp);
                let match;
                if (typeof cmd === 'string') {
                    match = yield this.socket.send(cmd, regExp, tags, sendOptions);
                }
                else {
                    match = yield this.request(cmd, tags, sendOptions, regExp);
                }
                const valueStr = match.find((m, i) => i > 0 && m !== undefined);
                if (valueStr === undefined) {
                    if (busyMs !== undefined)
                        this.state.busy.update(false);
                    throw new UserDriverError(`no match for ${control} set response`);
                }
                if (config.set.match.ack !== undefined) {
                    let compareValue = valueStr;
                    let acks = Array.isArray(config.set.match.ack)
                        ? config.set.match.ack
                        : [config.set.match.ack];
                    if (config.set.match.regExp.ignoreCase) {
                        acks = acks.map(a => a.toLowerCase());
                        compareValue = compareValue.toLowerCase();
                    }
                    if (acks.includes(compareValue))
                        returnValue = value;
                }
                // TODO: handle retry
                if (config.set.match.error !== undefined) {
                    let compareValue = valueStr;
                    let errors = Array.isArray(config.set.match.error)
                        ? config.set.match.error
                        : [config.set.match.error];
                    if (config.set.match.regExp.ignoreCase) {
                        errors = errors.map(e => e.toLowerCase());
                        compareValue = compareValue.toLowerCase();
                    }
                    if (errors.includes(compareValue))
                        return undefined;
                }
                if (returnValue === undefined) {
                    returnValue = parse(valueStr, (_b = config.set.match.format) !== null && _b !== void 0 ? _b : config.set.format);
                }
            }
            if (config.set.suspendMs !== undefined) {
                const suspendMs = config.set.suspendMs === undefined || typeof config.set.suspendMs === 'number'
                    ? config.set.suspendMs
                    : (_c = Object.values(config.set.suspendMs).find(map => map.key === valueFmt)) === null || _c === void 0 ? void 0 : _c.value;
                if (suspendMs !== undefined)
                    this.framework.suspend(suspendMs);
            }
            if (busyMs !== undefined) {
                this.busyTimeout.set(() => this.state.busy.update(false), busyMs);
            }
            return returnValue !== null && returnValue !== void 0 ? returnValue : value;
        });
    }
    validateAudio(key, filter) {
        var _a;
        const channel = this.getAudioChannel(key);
        if (channel === undefined)
            return 'missing';
        return ((_a = channel.filters) === null || _a === void 0 ? void 0 : _a[filter]) ? 'ok' : 'incompatible';
    }
}
UserDriverSocket.channelsConfigName = 'userDriverControlChannels';
UserDriverSocket.driverType = 'socketDriver';
UserDriverSocket.key = '-MxuPWsn1F_YHhMv54c0';
UserDriverSocket.socketOptions = (config) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y;
    let unterminatedRegExp;
    if ((_b = (_a = config.userDriver) === null || _a === void 0 ? void 0 : _a.commandExtractor) === null || _b === void 0 ? void 0 : _b.unterminatedRegExp) {
        try {
            unterminatedRegExp = createRegExp('command extractor unterminated', config.userDriver.commandExtractor.unterminatedRegExp);
        }
        catch (error) {
            throw new UserDriverError(`failed parsing socket options unterminated regular expression: ${unterminatedRegExp}`);
        }
    }
    return [
        {
            commandExtractor: {
                allowEmptyCommands: (_e = (_d = (_c = config.userDriver) === null || _c === void 0 ? void 0 : _c.commandExtractor) === null || _d === void 0 ? void 0 : _d.allowEmptyCommands) !== null && _e !== void 0 ? _e : false,
                terminators: (_h = (_g = (_f = config.userDriver) === null || _f === void 0 ? void 0 : _f.commandExtractor) === null || _g === void 0 ? void 0 : _g.terminators) !== null && _h !== void 0 ? _h : ['\r', '\n'],
                unterminatedRegExp: unterminatedRegExp,
            },
            idleTimeoutMs: (_k = (_j = config.userDriver) === null || _j === void 0 ? void 0 : _j.idleTimeoutMs) !== null && _k !== void 0 ? _k : 0,
            isBinary: (_m = (_l = config.userDriver) === null || _l === void 0 ? void 0 : _l.isBinary) !== null && _m !== void 0 ? _m : false,
            logReceivedData: (_p = (_o = config.userDriver) === null || _o === void 0 ? void 0 : _o.logReceivedData) !== null && _p !== void 0 ? _p : false,
            negotiateTelnet: (_r = (_q = config.userDriver) === null || _q === void 0 ? void 0 : _q.negotiateTelnet) !== null && _r !== void 0 ? _r : false,
            port: (_s = config.port) !== null && _s !== void 0 ? _s : 23,
            sendTerminator: (_u = (_t = config.userDriver) === null || _t === void 0 ? void 0 : _t.sendTerminator) !== null && _u !== void 0 ? _u : '\r',
            sendTimeoutMs: (_w = (_v = config.userDriver) === null || _v === void 0 ? void 0 : _v.sendTimeoutMs) !== null && _w !== void 0 ? _w : 2000,
            socketType: (_y = (_x = config.userDriver) === null || _x === void 0 ? void 0 : _x.socketType) !== null && _y !== void 0 ? _y : 'plain',
        },
    ];
};
